export const ShiftTableTitle = ({ title, className = null }) => {
  return (
    <h5 className={"text-axis-offblack fw-600" + " " + className}>{title}</h5>
  );
};
